import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import default styles
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'; // Import the CalendarMonthIcon
import { format, parse, isValid } from 'date-fns'; // Import format, parse, and isValid functions
import './DatePickerStyles.css';

interface DateRangePickerProps {
    startDateId: string;
    endDateId: string;
    onChange: (dates: { startDate: string; endDate: string }) => void;
    value: { startDate: string; endDate: string };
    className?: string;
}
const DateRangePicker: React.FC<DateRangePickerProps> = ({
    startDateId,
    endDateId,
    onChange,
    value,
    className = "",
}) => {
    const today = new Date();
    const handleStartDateChange = (date: Date | null) => {
        const formattedStartDate = date ? format(date, 'yyyy-MM-dd') : '';
        onChange({
            startDate: formattedStartDate,
            endDate: date && value.endDate && date > parse(value.endDate, 'yyyy-MM-dd', new Date()) ? '' : value.endDate,
        });
    };
    const handleEndDateChange = (date: Date | null) => {
        const formattedEndDate = date ? format(date, 'yyyy-MM-dd') : '';
        onChange({
            startDate: value.startDate,
            endDate: formattedEndDate,
        });
    };
    const handleStartDateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, 'dd/MM/yyyy', new Date());
        if (isValid(parsedDate)) {
            handleStartDateChange(parsedDate);
        } else {
            handleStartDateChange(null); // Reset to null if the date is invalid
        }
    };
    const handleEndDateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, 'dd/MM/yyyy', new Date());
        if (isValid(parsedDate)) {
            handleEndDateChange(parsedDate);
        } else {
            handleEndDateChange(null); // Reset to null if the date is invalid
        }
    };
    return (
        <div className={`flex flex-row md:flex-row md:space-x-4 space-y-4 md:space-y-0 ${className}`}>
            <div className="relative">
            {/* <label htmlFor={startDateId} className="block text-sm font-medium text-gray-700">Start Date</label> */}
                <DatePicker
                    id={startDateId}
                    selected={value.startDate ? new Date(value.startDate) : null}
                    onChange={handleStartDateChange}
                    dateFormat="dd/MM/yyyy"
                    maxDate={today}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    customInput={
                        <div className="flex items-center">
                            <CalendarMonthIcon className="absolute right-3" />
                            <input
                                className="w-80 pl-2 px-4 py-2 border border-gray-300 rounded-lg shadow-sm transition duration-300 ease-in-out hover:border-blue-400 hover:shadow-md focus:outline-none focus:border-blue-500"
                                type="text"
                                value={value.startDate ? format(new Date(value.startDate), 'dd/MM/yyyy') : ''}
                                onChange={handleStartDateInputChange}
                                 placeholder="Start Date"
                            />
                        </div>
                    }
                />
            </div>
            <div className="relative">
            {/* <label htmlFor={endDateId} className="block text-sm font-medium text-gray-700">End Date</label> */}
                <DatePicker
                    id={endDateId}
                    selected={value.endDate ? new Date(value.endDate) : null}
                    onChange={handleEndDateChange}
                    dateFormat="dd/MM/yyyy"
                    minDate={value.startDate ? new Date(value.startDate) : today}
                    maxDate={today}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    customInput={
                        <div className="flex items-center">
                            <CalendarMonthIcon className="absolute right-3" />
                            <input
                                className="w-80 pl-2 px-4 py-2 border border-gray-300 rounded-lg shadow-sm transition duration-300 ease-in-out hover:border-blue-400 hover:shadow-md focus:outline-none focus:border-blue-500"
                                type="text"
                                value={value.endDate ? format(new Date(value.endDate), 'dd/MM/yyyy') : ''}
                                onChange={handleEndDateInputChange}
                                 placeholder="End Date"
                            />
                        </div>
                    }
                />
            </div>
        </div>
    );
};
export default DateRangePicker;